import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { submitLtiForm } from 'store/Course/actions'
import { fetchLtiContent } from 'store/Course/actions'
import LtiPlayer from './LtiPlayer'

const ViewLti = (props) => {
	const dispatch = useDispatch()

	console.log('view lti proops', props)
	return (
		<div className='h-100'>
			<LtiPlayer
				fetchLtiContent={fetchLtiContent}
				submitLtiForm={(params, id) => dispatch(submitLtiForm(params, id))}
				{...props}
			/>
		</div>
	)
}
export default ViewLti
